import { render } from "./IconCaptions.vue?vue&type=template&id=fa907a08"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCaptions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa907a08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa907a08', __exports__)) {
    api.reload('fa907a08', __exports__)
  }
  
  module.hot.accept("./IconCaptions.vue?vue&type=template&id=fa907a08", () => {
    api.rerender('fa907a08', render)
  })

}


export default __exports__